export default __webpack_public_path__ + "static/media/Settings.448b5892.svg";